import { connect } from 'react-redux';
import { ErrorPageWithTranslations } from './error-page.component';
import { IErrorPageStoreProps } from './error-page.types';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State): IErrorPageStoreProps => ({
    platform: state.friendsReferral?.invitationInfo?.platformId,
    shouldInheritStyles: state.config.shouldInheritStyles
});

export default connect<IErrorPageStoreProps>(mapStateToProps)(ErrorPageWithTranslations);
